import React from 'react';
import ComingSoon from '../../components/ComingSoon';

export default function ReportingDashboard() {
    return <ComingSoon moduleName="Reporting Dashboard" description="Quick access to frequently run reports, scheduled reports status, and recent downloads." estimatedPhase="Phase 6 (Weeks 14-15)" priority="MEDIUM" />;
}
